import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import Analytics from './components/Analytics';
import 'focus-visible'; // Add keyboard focus styles for better accessibility
import './index.css';

try {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    document.body.innerHTML = '<div style="padding: 20px; font-family: sans-serif;"><h1>Error: Root element not found</h1><p>The application could not start because the root element is missing.</p></div>';
    throw new Error('Root element not found');
  }

  const root = createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <HelmetProvider>
        {/* Skip to content link for keyboard users */}
        <a
          href="#main-content"
          className="skip-link"
        >
          Skip to main content
        </a>

        <App />
        <Analytics />
      </HelmetProvider>
    </React.StrictMode>
  );
} catch (error) {
  console.error('[MAIN] Fatal error during initialization:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: sans-serif; max-width: 600px; margin: 50px auto; border: 2px solid red; border-radius: 8px;">
      <h1 style="color: red;">Application Failed to Start</h1>
      <p><strong>Error:</strong> ${error instanceof Error ? error.message : String(error)}</p>
      <p>Please check the browser console for more details.</p>
      <button onclick="window.location.reload()" style="padding: 10px 20px; font-size: 16px; cursor: pointer;">
        Reload Page
      </button>
    </div>
  `;
}